import {createReducer, on} from '@ngrx/store';
import {UploadActions} from '../actions/upload.actions';
import {UploadState} from '../../interfaces/upload-state.interface';
import {AblageortPath} from '../../types/ablageort-path.type';

export const initialUploadState: UploadState = {
  isDialogOpen: false,
  isUploading: false,
  uploadProgress: 0,
  error: null,
  lastUploadedDocument: null,
  lastUploadedFileName: null,
  lastUploadedPath: null,
  lastUploadedAblageort: null,
  pendingNavigation: false,
};

export const uploadReducer = createReducer(
  initialUploadState,

  on(
    UploadActions.openDialog,
    (state) => ({
      ...state,
      isDialogOpen: true,
      error: null,
    })
  ),

  on(
    UploadActions.closeDialog,
    (state) => ({
      ...state,
      isDialogOpen: false,
    })
  ),

  on(
    UploadActions.startUpload,
    (state, {fileName, displayPath, ablageort}) => ({
      ...state,
      isUploading: true,
      uploadProgress: 0,
      error: null,
      lastUploadedFileName: fileName,
      lastUploadedPath: displayPath,
      lastUploadedAblageort: ablageort as AblageortPath,
    })
  ),

  on(
    UploadActions.uploadProgress,
    (state, {progress}) => ({
      ...state,
      uploadProgress: progress,
    })
  ),

  on(
    UploadActions.uploadSuccess,
    (state, {dokument}) => ({
      ...state,
      isUploading: false,
      uploadProgress: 100,
      lastUploadedDocument: dokument,
      pendingNavigation: true,
    })
  ),

  on(
    UploadActions.uploadFailure,
    (state, {message}) => ({
      ...state,
      isUploading: false,
      uploadProgress: 0,
      error: message,
    })
  ),

  on(
    UploadActions.navigationCompleted,
    (state) => ({
      ...state,
      pendingNavigation: false,
      lastUploadedAblageort: null,
    })
  ),

  on(
    UploadActions.resetState,
    (state) => ({
      ...initialUploadState,
      // Navigation-Daten beibehalten (werden erst nach erfolgreicher Navigation zurückgesetzt)
      pendingNavigation: state.pendingNavigation,
      lastUploadedAblageort: state.lastUploadedAblageort,
    })
  ),
);
